import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { OptionFilter } from '@periscopes/general/filters';
export const ActiveFilter = (props) => {
    var _a;
    const { format, id, label, onChange, value } = props;
    const options = [
        {
            label: capitalize(label !== null && label !== void 0 ? label : ''),
            value: 'true'
        },
        {
            label: `Not ${capitalize(label !== null && label !== void 0 ? label : '')}`,
            value: 'false'
        }
    ];
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: { value: (_a = options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), onChange: (active) => onChange({
                [id]: {
                    format,
                    value: active
                }
            }), options: options, placeholder: PLACEHOLDERS_COPY.FILTER_BY(capitalize(label)), showArrow: true, value: value })));
};
